const AiGenConsts = {
    FETCH_IMAGES_SUCCESS: 'FETCH_IMAGES_SUCCESS',
    FETCH_IMAGES_FAILURE: 'FETCH_IMAGES_FAILURE',
    SET_POLL_DATA: 'SET_POLL_DATA',
    SET_VOTES_DATA: 'SET_VOTES_DATA',
    VOTE_SUCCESS: 'VOTE_SUCCESS',
    VOTE_FAILURE: 'VOTE_FAILURE',
};

export default AiGenConsts;